export default {
  root: {
    margin: 0,
    width: '100%',
    '& input': {
      padding: 8,
      fontSize: '1.5rem',
    },
  },
};
